import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@2.0.0-beta.1_@parcel+watcher@2.5.1_@types+node@24.0.1_db0@0.3.2_es_ulidbjpq5jpmd644cooejmwneq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}